import {
    IconDefinition,
    faFacebook,
    faInstagram,
    faLinkedin,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { Col, Row } from 'react-bootstrap';
import { Icon } from 'src/ui/shared/components/icon/Icon';

interface SocialProps {
    href: string;
    icon: IconDefinition;
    title: string;
}

const SocialLink = ({ href, title, icon }: SocialProps) => {
    return (
        <a
            className="btn btn-link-light px-2"
            href={href}
            target="_blank"
            rel="noreferrer"
            title={title}
        >
            <Icon size="2x" icon={icon} />
        </a>
    );
};

const Footer = () => {
    return (
        <div className="uc-footer-container pt-5 pb-5">
            <div className="uc-footer mx-auto text-light px-3">
                <Row className="mb-5">
                    <Col xs={12} md={6} className="mb-4 mb-md-0">
                        <img
                            src="https://cdn.content.careerhub.com.au/UC/component-images/uc_logo_inline_white.png"
                            height="40px"
                        />
                    </Col>
                    <Col xs={12} md={6} className="text-md-right">
                        <SocialLink
                            title="Facebook"
                            href="https://www.facebook.com/UCCareers"
                            icon={faFacebook}
                        />
                        <SocialLink
                            title="Instagram"
                            href="https://www.instagram.com/uccareers/"
                            icon={faInstagram}
                        />
                        <SocialLink
                            title="YouTube"
                            href="https://www.youtube.com/@careersuc4718"
                            icon={faYoutube}
                        />
                        <SocialLink
                            title="Tiktok"
                            href="https://www.linkedin.com/company/careers-uc/"
                            icon={faLinkedin}
                        />
                    </Col>
                </Row>
                <div className="mb-2">
                    <span>University of Canberra, Bruce ACT 2617 Australia</span>
                    <span className="mx-2">|</span>
                    <span>+61 2 6201 5111</span>
                    <span className="mx-2">|</span>
                    <span>ABN 81 633 873 422</span>
                    <span className="mx-2">|</span>
                    <span>CRICOS 00212K</span>
                    <span className="mx-2">|</span>
                    <span>TEQSA Provider ID: PRV12003 (Australian University)</span>
                </div>
                <div className="mb-4 terms-row">
                    <a href="https://www.canberra.edu.au/about-uc/contacts">Contact UC</a>
                    <span className="mx-2">|</span>
                    <a href="https://www.canberra.edu.au/about-uc/copyright/copyright">Copyright</a>
                    <span className="mx-2">|</span>
                    <a href="https://www.canberra.edu.au/about-uc/disclaimer-copyright-privacy-accessibility">
                        Disclaimer
                    </a>
                    <span className="mx-2">|</span>
                    <a href="https://www.canberra.edu.au/Policies/PolicyProcedure/Index/397">
                        Privacy
                    </a>
                </div>
                <hr className="bg-white mb-4" />
                <div>
                    UC acknowledges the Ngunnawal people, traditional custodians of the lands where
                    Bruce campus is situated. We wish to acknowledge and respect their continuing
                    culture and the contribution they make to the life of Canberra and the region.
                    We also acknowledge all other First Nations Peoples on whose lands we gather.
                </div>
            </div>
        </div>
    );
};

export default Footer;
